import Text from '../../../../../components/v4/Text';
import Heading from '../../../../../components/v4/Heading';
import {Box} from '@chakra-ui/react';

export default function ServiceWizardSyncUsersHeader({serviceWizard}) {
    return <></>;
}
